export const MENU_FIRST = "@mixfiscal:menu-first";

export const getMenuFirst = () => JSON.parse(localStorage.getItem(MENU_FIRST));

export const setSessionMenuFirst = body => {
  localStorage.setItem(MENU_FIRST, JSON.stringify(body));
};
